import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=bf5ea622&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=ts"
export * from "./BaseContainer.vue?vue&type=script&lang=ts"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=bf5ea622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ea622",
  null
  
)

export default component.exports